var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourcePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 56,
    viewBox: "0 0 97 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 67",
    d: "M23 14C23 11.7909 24.7909 10 27 10H69C71.2091 10 73 11.7909 73 14V56H23V14Z",
    fill: "#2C2D32"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 68",
    x: 32,
    y: 18,
    width: 32,
    height: 3,
    rx: 1.5,
    fill: "#EFEFEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 70",
    x: 32,
    y: 28,
    width: 32,
    height: 1,
    rx: 0.5,
    fill: "#EFEFEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 72",
    x: 32,
    y: 40,
    width: 32,
    height: 1,
    rx: 0.5,
    fill: "#EFEFEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 71",
    x: 32,
    y: 34,
    width: 32,
    height: 1,
    rx: 0.5,
    fill: "#EFEFEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 73",
    x: 32,
    y: 46,
    width: 32,
    height: 1,
    rx: 0.5,
    fill: "#EFEFEF",
    fillOpacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourcePlaceholder);
export default __webpack_public_path__ + "static/media/source_placeholder.ab22e9f46248a1554c13ce12ef8cc872.svg";
export { ForwardRef as ReactComponent };